import styled, { css } from 'styled-components';

const Container = styled.div`
  ${({ xsMobileColumns: xs }) => {
    if (xs === null || xs === undefined) return '';
    return css`
      display: grid;
      grid-template-columns: repeat(${xs}, 1fr);
      gap: ${xs > 1 ? '1rem' : '0'};

      /* Single Column */
      ${xs === 1 && css`
        & > * {
          margin-top: 1rem;
        }
        & > *:first-child {
          margin-top: 0;
        }
      `}
    `;
  }}

  ${({ mobileColumns }) => {
    if (mobileColumns === null || mobileColumns === undefined) return '';
    return css`
      @media ${({ theme }) => theme.breakpoints2026('S')} {
        grid-template-columns: repeat(${mobileColumns}, 1fr);
        gap: ${mobileColumns > 1 ? '1rem' : '0'};

        ${mobileColumns === 1 && css`
          & > * {
            margin-top: 1rem;
          }
          & > *:first-child {
            margin-top: 0;
          }
        `}

        ${mobileColumns > 1 && css`
          & > * {
            margin-top: 0;
          }
        `}
      }
    `;
  }}

  @media ${({ theme }) => theme.allBreakpoints('M')} {
    grid-template-columns: repeat(${({ columns }) => columns}, 1fr);
    gap: 1rem;

    & > * {
      margin-top: 0;
    }
  }

  @media ${({ theme }) => theme.allBreakpoints('L')} {
    gap: 1rem;
  }

  ${({ withMarginBottom }) => withMarginBottom && css`
    margin-bottom: 0.25rem;
    @media ${({ theme }) => theme.allBreakpoints('M')} {
      margin-bottom: 0.5rem;
    }
    @media ${({ theme }) => theme.allBreakpoints('L')} {
      margin-bottom: 1rem;
    }
  `}
`;

export default Container;
